import { useEffect, useState } from 'react';
import { imgs } from '../assets/imgs';
import { svgs } from '../assets/svgs';
import { Banner, CountDown, HSRegisterForm, TestimonialCarousel } from '../components';
import { NavLink, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useResizeImg } from '../hooks/useResizeImg';


const tabs = [
   { name: 'STARTUPS', bgColor: 'linear-gradient(180deg, #0008C5 0%, #001C64 99.99%)', link: 'startups' },
   { name: 'INVESTORS', bgColor: 'linear-gradient(180deg, #106B2A 0%, #457C55 100%)', link: 'investors' },
   { name: 'GENERAL ATTENDEES', bgColor: 'linear-gradient(180deg, #312948 0%, #7E5FD6 100%)', link: 'general' },
]


const deadline = new Date('September 01 2023 00:00:00 PST')
const DISCOUNT = deadline > Date.now() ? 200 : false

export const Register = () => {
   document.title = "New York Venture Summit | Registration";

   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(imgs.register.registerBannerDesktop, imgs.register.registerBannerMobile)
   const navigate = useNavigate()
   const { type } = useParams()
   const { search } = useLocation()

   useEffect(() => {
      if (!type) navigate('startups' + search)
   }, [type])

   useEffect(() => {
      var bz = document.createElement("script");
      bz.type = "text/javascript";
      bz.async = true;
      bz.src = "https://organizer.bizzabo.com/widgets/tickets/tickets.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(bz, s);
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: "8b0104df-57bf-4a46-bef7-b8e2b9fad4d1",
               region: "na1",
               target: '#preregForm'
            })
         }
      });
   }, []);

   return (
      <div className='register'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               {/* <h2 >Get Your Tickets {DISCOUNT && <span>Now</span>}</h2>
               <h1>Register Now {DISCOUNT && <span>and Save ${DISCOUNT}</span>}</h1>
               {DISCOUNT && <div>
                  <h2>Use Promo Code: early{DISCOUNT}</h2>
                  <h5>Pre-registration savings available for a limited time</h5>
               </div>}
            </section>
            {DISCOUNT && <section >
               {deadline > new Date() && < CountDown deadline={deadline} />} */}
               <h1>SOLD OUT</h1>
               <p>A limited number of at the door registrations will be available on a first come first serve basis.</p>
            </section>
         </Banner>
         {/* <nav>
            {
               tabs.map((tab, index) =>
                  <NavLink key={tab.link} className={type === tab.link ? 'btn b3' : 'btn b4'} style={{ background: type === tab.link && tab.bgColor }} to={tab.link}>{tab.name}</NavLink>
               )
            }
         </nav>
         <Outlet context={[DISCOUNT]} /> */}

         <HSRegisterForm />

         <TestimonialCarousel pageName={"registration;"} />
         {/* <div
            id="biza-prc-div"
            className="bizzabo-tickets-widget"
            data-event-id="491957"
            data-params="isInMinisite=true&widgetId=291159"
         /> */}
      </div>
   )
}

